import { render, staticRenderFns } from "./TempConfigQuestion.vue?vue&type=template&id=77f84f7e&scoped=true"
import script from "./TempConfigQuestion.vue?vue&type=script&lang=js"
export * from "./TempConfigQuestion.vue?vue&type=script&lang=js"
import style0 from "./TempConfigQuestion.vue?vue&type=style&index=0&id=77f84f7e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f84f7e",
  null
  
)

export default component.exports